import Locale from 'rmc-calendar/lib/locale/zh_CN';
export default Locale;
